import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the client directory still reads from the workspace: the directory rows, paging, sort, filters, columns and selection (the toolbar, saved views and start-up code drive them), the row actions' popups and the loaders.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsDirectoryHost = Pick<
  PmWorkspaceComponent,
  | 'applyClientsAddContactModalDefaults'
  | 'clearClientsSelection'
  | 'clientCodeFromRow'
  | 'clientInitials'
  | 'clientNameDisplay'
  | 'clientRowStatus'
  | 'clientRowStatusForRow'
  | 'clientsActiveAdvancedFilterCount'
  | 'clientsAddContactModalOpen'
  | 'clientsAnalyticsBaselineRows'
  | 'clientsAnalyticsRevenueByClient'
  | 'clientsAnalyticsStripOpen'
  | 'clientsBulkModal'
  | 'clientsBulkSaving'
  | 'clientsBulkSelectionCount'
  | 'clientsCapiumPayAccess'
  | 'clientsCapiumPayCountries'
  | 'clientsCapiumPayInviteDraft'
  | 'clientsCapiumPayInviteModalOpen'
  | 'clientsCapiumPayInviteRow'
  | 'clientsCapiumPayInviteSaving'
  | 'clientsCatalogHeaderLabel'
  | 'clientsDirectoryApiActive'
  | 'clientsDirectoryFirstLoadDone'
  | 'clientsDirectoryLoadFailed'
  | 'clientsDirectoryLoading'
  | 'clientsDirectoryPageNumber'
  | 'clientsDirectoryPageSize'
  | 'clientsDirectoryTotalCount'
  | 'clientsListAddContactClientName'
  | 'clientsListAddContactClientUniversalId'
  | 'clientsListAddContactCompanyMasterId'
  | 'clientsListRowActionsOpenId'
  | 'clientsListUnassignConfirmOpen'
  | 'clientsListUnassignTarget'
  | 'clientsListUnassigningId'
  | 'clientsPageTab'
  | 'clientsRowCheck'
  | 'clientsSelectedListRows'
  | 'clientsSortDir'
  | 'clientsSortField'
  | 'clientsSortedRows'
  | 'clientsSwitchLoading'
  | 'clientsTableVisibleOrderedColumns'
  | 'clientsTypeBadgeTone'
  | 'clientsViewMode'
  | 'closeClientsCapiumPayInviteModal'
  | 'closeClientsListRowActions'
  | 'copyChValue'
  | 'effectiveDirectoryParentUserId'
  | 'loadClientsAddMasterDataFromClientStore'
  | 'loadDirectoryClientsPage'
  | 'openClientsAddFormModalForEdit'
  | 'stopProp'
>;

export const PM_CLIENTS_DIRECTORY_HOST = new InjectionToken<PmClientsDirectoryHost>('PmClientsDirectoryHost');
